import { createEvent, restore, sample } from 'effector'
import { fx } from 'src/libs'
import {
  ApiListResponse,
  Difference,
  DifferenceFilter,
} from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/types'
import { normalizeObject } from 'src/pages/finSystem/balanceSummary/reports/utils'

export const exDifferenceListLoad = createEvent<DifferenceFilter>()
export const resetExDifferenceList = createEvent()

export const getExDifferenceListFx = fx<
  any | void,
  ApiListResponse<Difference>
>({
  method: 'GET',
  url: `/finance/report/exchange-diff`,
})

export const $exDifferenceList = restore<ApiListResponse<Difference>>(
  getExDifferenceListFx.doneData.map((res) => res.body),
  null,
).reset(resetExDifferenceList)

export const $walletOptions = $exDifferenceList.map((data) => {
  if (!data) return []

  const map = new Map<number, { label: string; value: string }>()

  data.items.forEach((item) => {
    if (!map.has(item.walletId)) {
      map.set(item.walletId, {
        label: item.walletName,
        value: String(item.walletId),
      })
    }
  })

  return Array.from(map.values()).sort((a, b) =>
    a.label.localeCompare(b.label, 'ru', { sensitivity: 'base' }),
  )
})

export const $currencyOptions = $exDifferenceList.map((data) => {
  if (!data) return []

  const map = new Map<string, { label: string; value: string }>()

  data.items.forEach((item) => {
    if (!map.has(item.currency)) {
      map.set(item.currency, {
        label: item.currency,
        value: item.currency,
      })
    }
  })

  return Array.from(map.values())
})

sample({
  clock: exDifferenceListLoad,
  filter: (filters) => !!(filters.dateFrom && filters.dateTo),
  fn: (filters) => {
    const requestObject = normalizeObject(filters)

    if (!requestObject || Object.keys(requestObject).length === 0) {
      return {}
    }
    const query: any = {}

    const { sorterField, search, ...rest } = requestObject

    if (sorterField) query['order'] = requestObject.sorterField
    if (search) query['search'] = requestObject.search

    if (Object.keys(rest).length !== 0) query['where'] = JSON.stringify(rest)

    return { query }
  },
  target: getExDifferenceListFx,
})
